import { render, staticRenderFns } from "./AddEditEDocumentVersion.vue?vue&type=template&id=6f828f59&scoped=true"
import script from "./AddEditEDocumentVersion.vue?vue&type=script&lang=js"
export * from "./AddEditEDocumentVersion.vue?vue&type=script&lang=js"
import style0 from "./AddEditEDocumentVersion.vue?vue&type=style&index=0&id=6f828f59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f828f59",
  null
  
)

export default component.exports